import gql from 'graphql-tag';
export const StatFeatureStaffLeaveV2 = gql `
    fragment StatFeatureStaffLeaveV2 on StaffLeaveFeatureSettingsFlags {
        isEnabled
    }
`;
